<template>
	<Col>CustomizeNotificationAppIcon</Col>
</template>
<script>
export default {
	name: 'CustomizeNotificationAppIcon',
	components: {},
	props: {},
	computed: {},
	methods: {},
	data() {
		return {};
	},
};
</script>
<style scoped lang="scss"></style>
